import type { ReactNode } from 'react';

export const symbol_flash_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m664-820-64 220h74q26.87 0 39.94 24Q727-552 711-529l-59 85q-8.43 11.05-22.21 12.53Q616-430 606-440q-8-8-8.5-18t5.5-19l43-63h-86q-15.45 0-24.73-12-9.27-12-4.27-26l70-242H310q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h308q23 0 38 18.5t8 41.5ZM792-83 561-313 441-139q-5 7-11.5 8.5t-13.4-.66q-6.9-2.15-11.5-7.54-4.6-5.39-4.6-13.3v-248h-60q-24.75 0-42.37-17.63Q280-435.25 280-460v-134L82-792q-9-9.07-9-21.53Q73-826 82.05-835q9.06-9 21.5-9 12.45 0 21.45 9l710 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83ZM463-639Z"
		/>
	</svg>
);
